// Imports
// React
import React from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';

// Components
import AuthPage from '../pages/AuthPage';
import CalendarPage from '../pages/CalendarPage';
import LandingPage from '../pages/LandingPage';
import MaintenancePage from '../pages/MaintenancePage';
import ProfilePage from '../pages/ProfilePage';
import ProtectedRoute from './ProtectedRoute';
import { NavigationBar } from '../modules/navigationbar/components/NavigationBar';

// Hooks
import { useFeatureFlag } from '../services/featureFlags/hooks/useFeatureFlag';

// Component Definition
export const AppRoutes: React.FC = () => {
  // Hooks
  const location = useLocation();
  const navigate = useNavigate();
  const { isEnabled: isMaintenanceMode } = useFeatureFlag('enable-maintenance');

  // Effects
  React.useEffect(() => {
    // Redirect to maintenance page if maintenance mode is enabled and not already on maintenance page
    if (isMaintenanceMode && location.pathname !== '/maintenance') {
      navigate('/maintenance');
    }
    // Redirect to home page if maintenance mode is disabled and on maintenance page
    else if (!isMaintenanceMode && location.pathname === '/maintenance') {
      navigate('/');
    }
  }, [isMaintenanceMode, location, navigate]);

  // Main Render
  return (
    <div className="min-h-screen bg-white dark:bg-black">
      {!isMaintenanceMode && location.pathname !== '/auth' && location.pathname !== '/' && (
        <NavigationBar />
      )}
      <main className="page-content">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/maintenance" element={<MaintenancePage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/profile" element={<ProfilePage />} />
          </Route>
        </Routes>
      </main>
    </div>
  );
};
